import React from "react";

import DetailsWrapper from "./DetailsWrapper";

function Radiology({ data }) {
  return <DetailsWrapper table={"radiology"} data={data} />;
}

export default Radiology;
